
import { DataGrid } from "@mui/x-data-grid";
import * as React from "react";
import { Box } from "@mui/material";
import CircularIndeterminate from "../Windows/Loader";
import { getLosers } from "../../redux/action/marketActions";
import { useDispatch } from "react-redux";
import { Button } from "@material-ui/core";

export const LosersList = ({
  setInstrumentForOrder,
  setOpen
}) => {
  const [losersData, setLosersData] = React.useState([])
  const [loader, setLoader] = React.useState(true);
  const dispatch = useDispatch();

  React.useEffect($ => {
    dispatch(getLosers(setLosersData))
  }, [dispatch])

  const watchlistbuttons = ({ row }) => {
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={($) => {
            setInstrumentForOrder({
              symbol: row.symbol,
              lastPrice: row.ltp,
              companyName: row.symbol
            });
            setOpen("buy");
          }}
        >
          Buy
        </Button>
        &nbsp;
        <Button
          variant="contained"
          color="secondary"
          size="small"
          onClick={($) => {
            setOpen("sell");
            setInstrumentForOrder({
              symbol: row.symbol,
              lastPrice: row.ltp,
              companyName: row.symbol
            });
          }}
        >
          Sell
        </Button>
      </>
    );
  };

  React.useEffect($ => setTimeout($ => setLoader(false), 2500))

  const columns = [

    { field: "symbol", headerName: "Symbol", width: 140 },
    {
      field: "ltp",
      headerName: "Last Traded Price",
      width: 140,
    },
    {
      field: "openPrice",
      headerName: "Open Price",
      width: 90,
    },
    {
      field: "previousPrice",
      headerName: "Previous Close",
      width: 120,
    },
    {
      field: "lowPrice",
      headerName: "Day Low",
      width: 90,
    },
    {
      field: "highPrice",
      headerName: "Day High",
      width: 90,
    },
    {
      field: "buttons",
      headerName: "Actions",
      width: 300,
      renderCell: watchlistbuttons,
      disableClickEventBubbling: true,
    }


  ];

  return (

    <Box
      sx={{
        height: 500,
        width: "1",
        "& .super-app.negative": {
          color: "red",
        },
        "& .super-app.positive": {
          color: "green",
        },
      }}
    >
      {(losersData.length === 0) ? <CircularIndeterminate /> : <DataGrid
        columns={columns}
        rows={losersData}
        rowHeight={70}
        getRowId={(row) => row.symbol}
      />}
    </Box>
  );
};

